<script>
export default {
	props: {
		data: Object,
		transparent: Boolean,
	},
	computed: {
		cSlidesPerPage() {
			return this.data.imagesCarousel?.length > this.data.slidesPerPage
				? Number(this.data.slidesPerPage)
				: this.data.imagesCarousel?.length
		},
	},
}
</script>

<template>
	<AppBar-MenuWithActivator
		:transparent="transparent"
		:button-props="{
			text: data.text,
			icon: data.icon,
			iconHtml: data.iconHtml,
			iconImage: data.iconImage,
			iconType: data.iconType,
		}"
	>
		<div class="d-flex justify-center align-center">
			<div class="w100" style="max-width: 1440px">
				<AppBar-ImagesCarousel :slides-per-page="cSlidesPerPage" :slides="data.imagesCarousel" />
			</div>
		</div>
	</AppBar-MenuWithActivator>
</template>

<style scoped lang="scss"></style>

